import React, { Component } from 'react'
import {Grid} from 'semantic-ui-react';
import data from '../../assets/json/about/accreditation.json';
import headerBorder from '../../assets/images/line-orange.png';

export default class Accreditation extends Component {
	state = {
		data: data.accreditation
	};
	
	
  render() {
	let {data} = this.state;
	var createReactClass = require('create-react-class');
		var ImagePreview = createReactClass({
			getInitialState() {
				return {
				  hover: false
				};
			},
			render: function(){
				return (
					<div>
						<img src={this.props.src} alt="" className="icn-accreditation"/>
					</div>
				);
			}
		});
		
		return (
			<>
				<Grid >
					<Grid.Column width={16} className="align-center">
						<h1 className="section-header align-center">Accreditations</h1>
						<img src={headerBorder} className="header-border align-center" alt="" />
					</Grid.Column>	
				</Grid>
				<Grid className="accreditation-wrapper">
					{
						data.map((img,i) => (
							<Grid.Column width={4}  verticalAlign="middle" className="our-mission-wrapper" key={i}>
								<ImagePreview
									src={img.photo}
									caption={img.caption}
								/>
							</Grid.Column>
						))
					}
				</Grid>
			</>
        );
	}
}